export default __webpack_public_path__ + "static/media/iam_m2.5f23ea85.png";